/** Supported UI languages — must match locale JSON files in ./locales */
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Español' },
  { code: 'fr', label: 'French', nativeLabel: 'Français' },
  { code: 'de', label: 'German', nativeLabel: 'Deutsch' },
  { code: 'pt', label: 'Portuguese', nativeLabel: 'Português' },
  { code: 'zh', label: 'Chinese (Simplified)', nativeLabel: '中文' },
  { code: 'ja', label: 'Japanese', nativeLabel: '日本語' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी' },
  { code: 'ar', label: 'Arabic', nativeLabel: 'العربية' },
] as const;

export type AppLocale = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export const RTL_LOCALES = new Set<AppLocale>(['ar']);

/** Set VITE_GA_ENGLISH_ONLY=true to hide the language picker (English-only mode). */
export const GA_ENGLISH_ONLY =
  import.meta.env.VITE_GA_ENGLISH_ONLY === 'true';

export const SELECTABLE_LANGUAGES = GA_ENGLISH_ONLY
  ? SUPPORTED_LANGUAGES.filter((l) => l.code === 'en')
  : [...SUPPORTED_LANGUAGES];

export function normalizeAppLocale(value?: string | null): AppLocale {
  const code = (value || 'en').split('-')[0].toLowerCase();
  return SUPPORTED_LANGUAGES.some((l) => l.code === code) ? (code as AppLocale) : 'en';
}

export function applyDocumentLanguage(locale: string): void {
  const code = normalizeAppLocale(locale);
  document.documentElement.lang = code;
  document.documentElement.dir = RTL_LOCALES.has(code) ? 'rtl' : 'ltr';
}
